export default __webpack_public_path__ + "static/media/dicks_logo.3f62fe53.svg";